import React from 'react';
import { addColumnSortLabels } from '@/presentation/components/commons/labels';
import { Badge } from '@cloudscape-design/components-themed/components';
import { getRandomUUID } from '@/lib/misc/utils';
import { getLocaleTimestamp } from '@/presentation/common-utils/common-utils';
import { companyNameFilteringProperty } from '@/presentation/pages/common-config';
export const MyProfileTokensTableColumnDefinitions = addColumnSortLabels([
    {
        id: 'id',
        sortingField: 'id',
        header: 'ID',
        cell: (item) => item === null || item === void 0 ? void 0 : item.id,
        width: 120
    },
    {
        id: 'clientID',
        sortingField: 'clientID',
        header: 'Client ID',
        cell: (item) => item === null || item === void 0 ? void 0 : item.clientID
    },
    {
        id: 'description',
        sortingField: 'description',
        header: 'Description',
        cell: (item) => item === null || item === void 0 ? void 0 : item.description,
    },
    {
        id: 'companyName',
        sortingField: 'companyName',
        header: 'Organization',
        cell: (item) => item === null || item === void 0 ? void 0 : item.companyName,
    },
    {
        id: 'status',
        sortingField: 'status',
        header: 'Status',
        cell: (item) => {
            return React.createElement(Badge, { key: getRandomUUID(), color: (item === null || item === void 0 ? void 0 : item.status) === 'ACTIVE' ? 'green' : 'grey' }, item === null || item === void 0 ? void 0 : item.status);
        }
    },
    {
        id: 'createdDate',
        sortingField: 'createdDate',
        header: 'Created',
        cell: (item) => getLocaleTimestamp(item === null || item === void 0 ? void 0 : item.createdDate)
    },
]);
export const defaultVisibleContentOptions = {
    id: { id: 'id', label: 'ID', editable: false },
    clientID: { id: 'clientID', label: 'Client ID', editable: false },
    description: { id: 'description', label: 'Description', editable: true },
    companyName: { id: 'companyName', label: 'Organization', editable: true },
    status: { id: 'status', label: 'Status', editable: true },
    createdDate: { id: 'createdDate', label: 'Created', editable: true }
};
export const MyProfileTokensTableVisibleContentOptions = [
    {
        label: null,
        options: Object.values(defaultVisibleContentOptions)
    }
];
export const MyProfileTokensTablePageSizeOptions = [
    { value: 10, label: '10 API Keys' },
    { value: 30, label: '30 API Keys' },
    { value: 50, label: '50 API Keys' }
];
export const MyProfileTokensFilteringProperties = [
    {
        key: 'id',
        operators: [':', '!:', '=', '!='],
        propertyLabel: 'ID',
        groupValuesLabel: 'ID values'
    },
    {
        key: 'clientID',
        operators: [':', '!:', '=', '!='],
        propertyLabel: 'Client ID',
        groupValuesLabel: 'Client ID values'
    },
    {
        key: 'description',
        operators: [':', '!:', '=', '!='],
        propertyLabel: 'Description',
        groupValuesLabel: 'Description values'
    },
    companyNameFilteringProperty,
    {
        key: 'status',
        operators: ['=', '!='],
        propertyLabel: 'Status',
        groupValuesLabel: 'Status values'
    }
];
export const MyProfileTokensFilteringOptions = [
    {
        propertyKey: 'status',
        value: 'ACTIVE'
    },
    {
        propertyKey: 'status',
        value: 'REVOKED'
    }
];
export const MyProfileTokensTablePreferences = {
    pageSize: 30,
    visibleContent: ['id', 'clientID', 'description', 'companyName', 'status', 'createdDate'],
    wrapLines: false,
    custom: {
        autoResize: true
    }
};
